import { HStack, NumberInput, Text } from "@chakra-ui/react";

interface Props {
  value: number;
  setValue: (value: number) => void;
}

export const DollarInput = ({ value, setValue }: Props) => {
  return (
    <HStack gap={2}>
      <Text fontSize="lg" fontWeight="bold" color="gray.500">$</Text>
      <NumberInput.Root
        value={value}
        onValueChange={(details: any) => {
          // If details.valueAsNumber exists, use it; otherwise parse details.value
          if (typeof details.valueAsNumber === "number") {
            setValue(details.valueAsNumber);
          } else {
            const num = parseFloat(details.value);
            if (!isNaN(num)) {
              setValue(num);
            }
          }
        }}
        flex={1}
      >
        <NumberInput.Control />
        <NumberInput.Input />
      </NumberInput.Root>
    </HStack>
  );
};
